import { action, observable } from "mobx";
import { Logger } from "bernie-logger";
import { SerializedData, Store } from "bernie-core";
import { ExtendedTemplateComponent } from "./typings";
import { ExperienceTemplate } from "experience-template-renderer-react";
import { Composition as FlexComposition, Template as FlexTemplate } from "src/typings/flexFramework/FlexDefinitions";
import { flexToExtendedTemplateComponent } from "./flexToExtendedExperienceTemplateComponent";
import { DescendantDepth } from "./descendantDepth";
import { FlexComponent, ModuleDefinition } from "src/typings/flexFramework/FlexComponent";

export class ExperienceTemplateStore extends Store {
  public id?: string;

  public version?: string;

  @observable
  public components?: ExtendedTemplateComponent[];

  /* istanbul ignore next */
  public constructor(state: SerializedData = {}, logger: Logger) {
    super(state, logger);
  }

  /* istanbul ignore next */
  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  @action
  public setup(structureInput: FlexTemplate | FlexComposition | ExperienceTemplate) {
    const isFlexComposition = (
      structure: FlexTemplate | FlexComposition | ExperienceTemplate
    ): structure is FlexComposition => {
      return !!(structure as FlexComposition).page;
    };

    const isFlexTemplate = (
      structure: FlexTemplate | FlexComposition | ExperienceTemplate
    ): structure is FlexTemplate => {
      return !!(structure as FlexTemplate).regions;
    };

    const isExperienceTemplate = (
      structure: FlexTemplate | FlexComposition | ExperienceTemplate
    ): structure is ExperienceTemplate => {
      return !isFlexComposition(structure) && !isFlexTemplate(structure);
    };

    if (isExperienceTemplate(structureInput)) {
      this.id = structureInput.id;
      this.version = structureInput.version;
      this.components = structureInput.components as ExtendedTemplateComponent[];
    } else {
      // convert legacy Flex structures to ExperienceTemplate
      if (isFlexTemplate(structureInput)) {
        this.id = `${structureInput.id}`;
        this.version = `${structureInput.version}`;
        this.toExtendedTemplateComponents(structureInput.regions);
      } else {
        // isFlexComposition
        this.id = `${structureInput.templateId}`;
        this.version = `${structureInput.templateVersion}`;
        this.toExtendedTemplateComponents(structureInput.page.regionList);
      }
    }
  }

  public toExtendedTemplateComponents(flexEntities: FlexComponent[] | ModuleDefinition[]) {
    this.components = [];

    flexEntities.forEach((fe: FlexComponent | ModuleDefinition) => {
      this.components?.push(flexToExtendedTemplateComponent(fe, DescendantDepth.ALL));
    });
  }
}
